module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 133
// module chunks = 0